import React from "react";
import "../styles/EventPage.css";

interface PhotoGridProps {
  photos: string[];
  onAddPhoto?: () => void;
}

const PhotoGrid: React.FC<PhotoGridProps> = ({ photos, onAddPhoto }) => {
  if (!photos || photos.length === 0) {
    return (
      <div
        className="photo-grid empty"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "250px", 
          border: "2px dashed #ccc",
          borderRadius: "8px",
          cursor: onAddPhoto ? "pointer" : "default",
          backgroundColor: "#f0f0f0", 
          backgroundImage: "url('/path/to/background.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          padding: "20px",
        }}
        onClick={onAddPhoto}
      >
        <p style={{ color: "#555", fontWeight: "bold", margin: 0 }}>
          Aucune photo disponible
        </p>
      </div>
    );
  }

  return (
    <div className="photo-grid">
      {photos.map((p, i) => (
        <img key={i} src={p} alt={`photo-${i}`} className="photo-item" />
      ))}
    </div>
  );
};

export default PhotoGrid;
